<script>
  import { link } from "svelte-spa-router";
  import { urlServeur, pathImages } from "./conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";

  let rows;

  const tabcouleur = {
    Programmeur: "04A2FC",
    Formateur: "EACD13",
    "Chargée d'affaire": "88CA0C",
    "Secrétaire de direction - ass.": "8921F9",
    "Standardiste - Ass. administrative": "8921F9",
    Entretien: "5BD8F7",
    Alternance: "04A2FC",
    "Chef de projet": "04A2FC",
  };

  let searchTerm = "";
  let parti = false;
  //=============  Methodes ==============

  /**
   * creation des params pour l'url
   */
  const recupParamsUrl = () => {
    let url = "";

    if (searchTerm !== "") {
      url += "nom=" + searchTerm;
    }
    if (parti) {
      url += "parti=1";
    }
    if (url !== "") {
      url = "?" + url;
    }

    return url;
  };

  /**
   * Affichae HTML de la liste Hist_salaries
   * @param id
   */
  let displayInfo = (id) => {
    //alert("id = " + id);
    const element = document.getElementById("TAB_EMP_" + id);
    if (element.style.visibility === "hidden") {
      element.style.visibility = "visible";
    } else {
      element.style.visibility = "hidden";
    }
  };

  /**
   *  recherche des datas sur le serveur
   * api_employe/employes?id=xxx&nom=nom_personne&parti=0|1
   */
  const fetchData = async (q) => {
    const response = await fetch(
      urlServeur + "/api_employe/employes" + searchTerm
    );
    if (response.ok) {
      const result = await response.json();

      rows = result.payload;
      return rows;
    } else {
      throw new (Error(text))();
    }
  };

  let promise = fetchData();

  /***
   *  Action bouton chercher
   */
  const chercher = async (q) => {
    promise = fetchData();
    searchTerm = "";
  };
</script>

<div class="row">
  <div class="col-sm-3">
    Filtrer: <input bind:value={searchTerm} />
    <button
      on:click={() => chercher()}
      class="btn btn-light btn-sm bg-white has-icon btn-block volet"
      type="button">Chercher</button
    >
  </div>
</div>

{#await promise}
  <Spinner />
{:then elements}
  {#each elements as element}
    <div class="col-sm-3">
      <div
        class="card"
        style="text-align : center; border : 1px solid grey;margin-bottom : 15px;"
      >
        <img
          src="https://www.colorbook.io/imagecreator.php?hex={element.EM_PARTI_LE ==
          '1970-01-01'
            ? tabcouleur[element.EM_POSTE]
            : '04A2FC'}&width=340&height=100"
          alt="Cover"
          class="card-img-top"
        />
        <div class="card-body text-center">
          <img
            src="{pathImages}team/avatar_{element.EM_PARTI_LE == '1970-01-01'
              ? element.EM_ID
              : '00'}.jpg"
            style="width:100px;margin-top:-65px"
            alt="User"
            class="img-fluid img-thumbnail rounded-circle border-0 mb-3"
          />
          <h5 class="card-title">{element.EM_NOM}</h5>
          <p class="text-secondary mb-1">{element.EM_POSTE}</p>
          <p class="text-muted font-size-sm">
            Entré le : {element.EM_ENTRE_LE}
          </p>

          <div class:hidden={element.EM_PARTI_LE !== "1970-01-01"}>
            <br />
            <p class="text-muted font-size-sm danger">
              Parti le : {element.EM_PARTI_LE}
            </p>
          </div>
          <div class:hidden={element.EM_PARTI_LE == "1970-01-01"}>
            <p class="text-muted font-size-sm">
              <span>age : {element.AGE}</span> -
              <span>anc. : {element.OLD}</span>
            </p>
            <br />
          </div>
        </div>

        <!-- salaire 3 denieres années-->
        <div id="TAB_EMP_{element.EM_ID}" style="visibility : hidden;">
          {#if 0 in element}
            <table class="table table-responsive table-success table-striped">
              <tr>
                <td>année</td>
                <td>Sal</td>
                <td>mini</td>
                <td>Prime</td>
              </tr>
              {#each element[0]["info"] as donnee}
                <tr>
                  <td>{donnee.annee}</td>
                  <td>{donnee.minSal}</td>
                  <td>{donnee.maxSal}</td>
                  <td>{donnee.totPrime}</td>
                </tr>
              {/each}
            </table>
          {/if}
        </div>

        <div class="card-footer">
          <a href="/api_employe/employe/{element.EM_ID}" use:link
            ><i class="icon ion-md-person ml-3" />P</a
          >
          <a href="/#"><i class="icon ion-md-create ml-3" />C</a>
          <a href="/#"><i class="icon ion-md-pulse ml-3" />G</a>

          <button
            id={element.EM_ID}
            on:click={() => displayInfo(element.EM_ID)}
            class="btn btn-light btn-sm bg-white has-icon btn-block volet"
            type="button">Salaires</button
          >
        </div>
      </div>
    </div>
  {/each}
{:catch error}
  <p style="color: red">{error.message}</p>
{/await}

<style>
  .table {
    font-size: 0.75em;
  }
  .hidden {
    visibility: hidden;
  }
</style>
